<template>
  <div class="min-h-screen flex flex-col bg-base-200/30">
    <Header v-if="header && header == 'userHeader'" @toggle-menu="toggleMenu"/>

    <div class="flex flex-1">
      <div
        v-if="menu"
        class="w-64 shrink-0 lg:block"
        :class="{
          'hidden': !isMenuOpen && isMobileView,
          'fixed top-14 bottom-0 left-0 z-30 w-64 shadow-xl': isMobileView
        }"
      >
        <Menu v-if="menu == 'userMenu'"/>
        <QuestMenu v-if="menu == 'questMenu'"/>
        <ContactsMenu v-if="menu == 'contactsMenu'"/>
      </div>

      <main class="flex flex-col flex-1 min-w-0 p-4 lg:p-6">
        <router-view></router-view>
      </main>
    </div>

    <div
      v-if="isMenuOpen && isMobileView"
      class="fixed inset-0 top-14 bg-black/40 z-20 backdrop-blur-sm"
      @click="toggleMenu"
    ></div>

    <Footer v-if="footer && footer == 'globalFooter'"/>
    <ContactMessageModal />
    <CookieConsent />
  </div>
</template>
  
  <script setup>
  import Header from "./components/header/Header.vue";
  import Footer from "./components/footer/Footer.vue";
  import Menu from "./components/menu/Menu.vue";
  import QuestMenu from "./components/menu/QuestMenu.vue";
  import ContactsMenu from "./components/menu/ContactsMenu.vue";
  import CookieConsent from "./components/CookieConsent.vue";
  import ContactMessageModal from "./components/ContactMessageModal.vue";
  import { useSeo } from './compositions/useSeo'
  
  import { ref, watch, onMounted, onBeforeUnmount } from "vue";
  import { useRoute } from "vue-router";
  import direction from "./utils/direction"
  const route = useRoute();
  const menu  = ref(false);
  const header  = ref(false);
  const footer  = ref(false);
  const isMenuOpen = ref(false);
  const isMobileView = ref(false);
  
  
  const checkMobileView = () => {
    isMobileView.value = window.innerWidth < 1024; // lg breakpoint in Tailwind
    if (!isMobileView.value) {
      isMenuOpen.value = true; // On desktop, menu is always open
    } else {
      isMenuOpen.value = false; // On mobile, menu is closed by default
    }
  };
  
  const toggleMenu = () => {
    if (isMobileView.value) {
      isMenuOpen.value = !isMenuOpen.value;
    }
  };
  
  onMounted(() => {
    checkMobileView();
    window.addEventListener('resize', checkMobileView);
  });
  
  onBeforeUnmount(() => {
    window.removeEventListener('resize', checkMobileView);
  });
  
  useSeo();
  watch(route, (route) => {
    const dir = direction.filter(i => i.page == route.name)[0]
  
    // Sayfayı en üste kaydır
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    window.scrollTo(0, 0);
  
    if(dir){
      menu.value = typeof dir.menu === "undefined" ? direction[0].menu : dir.menu; 
      header.value = typeof dir.header === "undefined" ? direction[0].header : dir.header; 
      footer.value = typeof dir.footer === "undefined" ? direction[0].footer : dir.footer;          
    }else{
      menu.value = direction[0].menu;
      header.value = direction[0].header;
      footer.value = direction[0].footer;
    }
    
    // Sayfa değiştiğinde mobilde menüyü kapat
    if (isMobileView.value) {
      isMenuOpen.value = false;
    }
  });
  </script>
  
  <style>
  .menu-transition {
    transition: transform 0.3s ease-in-out;
  }
  </style>